import { render, staticRenderFns } from "./EinstellungenKorrespondenz.vue?vue&type=template&id=09a6d76d&"
import script from "./EinstellungenKorrespondenz.vue?vue&type=script&lang=js&"
export * from "./EinstellungenKorrespondenz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports